import { Card, Spinner } from "reactstrap";
import "./index.css";
import Typography from "Components/CommonComponents/Typography";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import CustomTabs from "utilFunctions/shared/CustomTabs";
import { useContext, useEffect, useState } from "react";
import AllCommentsListing from "Pages/StudentPortfolio/StudentCommentSection/AllCommentsListing";
import StudentAddComment from "Pages/StudentPortfolio/StudentCommentSection/StudentAddComment";
import DraggableModal from "utilFunctions/shared/DraggableModal";
import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import { useForm } from "react-hook-form";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import {
  BASE_URL,
  FETCH_LOP_ACTIONS,
  GET_COMMENTS_LIST,
} from "utilFunctions/Constants/urlConstants";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import { StudentContext } from "Context/StudentContext";
import styled from "styled-components";
import StudentInsightHome from "Pages/StudentPortfolio/StudentInsight/StudentInsightHome";
import useMasterContext from "Context/MasterContext";
// import TypingAnimation from "utilFunctions/shared/TypingAnimation";
const CardStyled = styled<any>(Card)`
  padding: 1px;
  background: #fff;
  height: ${(props) =>
    props.viewAllComments
      ? "calc(100vh - 130px) !important"
      : !props.isPerformanceVisible
      ? "calc(100vh - 100px) !important"
      : "calc(100vh - 260px) !important"};
`;

const StudentCommentSection = ({
  viewAllComments,
  setViewAllComments,
  isPaneOpen,
  setIsPaneOpen,
  commentsObj,
  setCommentsObj,
  isPerformanceVisible,
  isPaneOpenComment,
}: any) => {
  const { selectedStudent } = useContext<any>(StudentContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const userInfo = useContext<any>(UserInfoContext);
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const { lopReasons: lopReasonList } = masters || {};
  const [activeTab, setActiveTab] = useState<number>(0);
  const [mainactiveTab, setMainActiveTab] = useState<number>(0);
  const [offSet, setOffSet] = useState<number>(0);
  const [isNewCommentAdded, setIsNewCommentAdded] = useState<boolean>(false);
  const [lopActionList, setLopActionList] = useState<selectInterface[]>([]);
  const [limit] = useState<number>(100);
  const [refreshComment, setRefreshComment] = useState<boolean>(false);
  const [tabComponent, setTabComponent] = useState<any>({});
  const [isCommentEdit, setIsCommentEdit] = useState<boolean>(false);
  const [isAddNewComment, setIsAddNewComment] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    subj: null,
    ptmMode: null,
    lopReasons: [],
    lopAction: null,
    comment: "",
    type: "",
  });
  const [subjects, setSubjects] = useState<selectInterface[]>(
    userInfo?.subjects ? userInfo.subjects : []
  );
  const { makeRequest: GetLopActionList } = useGetApi(
    (data) => {
      if (data["data"] && data["data"].length) {
        const array: selectInterface[] = [];
        data["data"].map((el: any) => {
          array.push({
            label: el.action,
            value: el.id,
            key: el.id,
          });
        });
        setLopActionList(array);
      } else {
        setLopActionList([]);
      }
    },
    (error) => {
      setLopActionList([]);
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["message"],
      });
    }
  );
  const {
    makeRequest: GetPastComments,
    loading: isCommentLoader,
    responseData,
    error,
  } = useGetApi(
    (data) => {
      console.log("isNewCommentAdded", data);
    },
    (error) => {
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    }
  );
  //GET SUBJECTS
  useEffect(() => {
    const newArray: selectInterface[] = [
      {
        label: "General",
        key: "general",
        value: "general",
      },
    ];
    if (userInfo && userInfo?.subjects && Array.isArray(userInfo["subjects"])) {
      userInfo["subjects"].map((ele: any) => {
        newArray.push({
          label: ele.subjectName,
          key: ele.id,
          value: ele.subjectName,
        });
      });

      setSubjects(newArray);
    }
  }, [userInfo]);
  useEffect(() => {
    if (responseData && responseData != null) {
      console.log(
        "responseData",
        responseData["data"],
        offSet,
        isNewCommentAdded
      );

      const followUpComments = responseData["data"].filter(
        (item: any) =>
          item.type == "followup" || item.type == "lop" || item.type == "LOP"
      );
      const ptmComments = responseData["data"].filter(
        (item: any) => item.type == "ptm"
      );
      const absenteeComments = responseData["data"].filter(
        (item: any) => item.type == "absentee"
      );
      setCommentsObj({
        allComments: responseData["data"],
        followUpComments: followUpComments,
        ptmComments: ptmComments,
        absenteeComments: absenteeComments,
      });

      setIsNewCommentAdded(false);
    }
  }, [responseData]);
  useEffect(() => {
    if (error && error != null) {
      console.log("errordata", error, offSet);
      setCommentsObj({
        allComments: [],
        followUpComments: [],
        ptmComments: [],
        absenteeComments: [],
      });
    }
  }, [error]);

  useEffect(() => {
    console.log("selectedStudent+++++", selectedStudent);
    if (selectedStudent?.psid) {
      setOffSet(0);
      GetPastComments(
        BASE_URL +
          GET_COMMENTS_LIST +
          `psid=${selectedStudent?.psid}&limit=` +
          limit +
          "&offset=0"
      );
    }
  }, [selectedStudent?.psid, refreshComment]);
  useEffect(() => {
    GetLopActionList(BASE_URL + FETCH_LOP_ACTIONS);
  }, []);
  const togglePane = () => {
    setIsPaneOpen(!isPaneOpen);
  };
  const onClosePaneHandler = () => {
    console.log("");
  };
  const CommentEditToggle = (comment: any) => {
    setFilterState(comment);
    setIsCommentEdit(true);
    setIsAddNewComment(!isAddNewComment);
  };
  const scrollToHeader = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  };
  const tabs = [
    {
      name: "All",
      label: "All: " + commentsObj?.allComments?.length,
      value: "All",
      component: (
        <AllCommentsListing
          isCommentLoader={isCommentLoader}
          commentArray={commentsObj?.allComments}
          mode="all"
          refreshComment={refreshComment}
          CommentEditToggle={CommentEditToggle}
          lopActionList={lopActionList}
          lopReasonList={lopReasonList}
        ></AllCommentsListing>
      ),
    },
    {
      name: "LOP",
      label: "LOP: " + commentsObj?.followUpComments?.length,
      value: "followUp",
      component: (
        <AllCommentsListing
          isCommentLoader={isCommentLoader}
          commentArray={commentsObj?.followUpComments}
          mode="followUp"
          refreshComment={refreshComment}
          CommentEditToggle={CommentEditToggle}
          lopActionList={lopActionList}
          lopReasonList={lopReasonList}
        ></AllCommentsListing>
      ),
    },
    {
      name: "PTM",
      label: "PTM: " + commentsObj?.ptmComments?.length,
      value: "ptm",
      component: (
        <AllCommentsListing
          isCommentLoader={isCommentLoader}
          commentArray={commentsObj?.ptmComments}
          mode="ptm"
          refreshComment={refreshComment}
          CommentEditToggle={CommentEditToggle}
          lopActionList={lopActionList}
          lopReasonList={lopReasonList}
        ></AllCommentsListing>
      ),
    },
    {
      name: "Absentee",
      label: "Absentee: " + commentsObj?.absenteeComments?.length,
      value: "absentee",
      component: (
        <AllCommentsListing
          isCommentLoader={isCommentLoader}
          commentArray={commentsObj?.absenteeComments}
          mode="absentee"
          refreshComment={refreshComment}
          CommentEditToggle={CommentEditToggle}
          lopActionList={lopActionList}
          lopReasonList={lopReasonList}
        ></AllCommentsListing>
      ),
    },
  ];
  // const ApiResponse = ({ response }: any) => {
  //   const formatText = (text: any) => {
  //     const lines = text.split("\n");

  //     return lines.map((line: any, index: number) => {
  //       if (line.includes(":")) {
  //         const [heading, ...rest] = line.split(":");
  //         return (
  //           <div className="insightContainer" key={index}>
  //             <strong className="insightContainerHeading">{heading}:</strong>{" "}
  //             {rest.join(":").trim()}
  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div className="insightContainerText" key={index}>
  //             {/* {line.trim()} */}
  //             <TypingAnimation text={line.trim()} speed={150} />
  //           </div>
  //         );
  //       }
  //     });
  //   };

  //   return <div className="insightContainerMain5">{formatText(response)}</div>;
  // };

  const maintabs = [
    {
      name: "Comment",
      label: "Comment",
      value: "Comment",
      component: (
        <>
          <div className="commentDropdownDivDK">
            <Typography
              variant={["xxl", "xl", "lg"].includes(screen) ? "h6" : "h6"}
              color="black"
            >
              Comments
            </Typography>
            <span
              onClick={() => {
                setViewAllComments(!viewAllComments);
              }}
              className="filterSpan"
            >
              {viewAllComments ? "Close" : "View all"}
            </span>
          </div>
          <div className="commentTabsDiv">
            {isCommentLoader ? (
              <div className="d-flex justify-content-center align-item-center">
                <Spinner color="info"></Spinner>
              </div>
            ) : (
              <CustomTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabs={tabs}
                className=" fontSizeTab"
                customTabCSS={
                  viewAllComments
                    ? " customCommentViewAllTabs"
                    : " customCommentTabs"
                }
                customContentCSS="customTabContentComment"
              />
            )}
            <StudentAddComment
              refreshComment={refreshComment}
              setRefreshComment={setRefreshComment}
              lopReasonList={lopReasonList}
              lopActionList={lopActionList}
              viewAllComments={viewAllComments}
              subjects={subjects}
              filterState={filterState}
              setFilterState={setFilterState}
              isAddNewComment={isAddNewComment}
              setIsAddNewComment={setIsAddNewComment}
              isCommentEdit={isCommentEdit}
              setIsCommentEdit={setIsCommentEdit}
              isPaneOpenComment={isPaneOpenComment}
              scrollToHeader={scrollToHeader}
            />
          </div>
        </>
      ),
    },
    {
      name: "Insights",
      label: "Insights",
      value: "Insights",
      component: (
        <StudentInsightHome
          viewAllComments={viewAllComments}
          setViewAllComments={setViewAllComments}
        />
      ),
    },
  ];

  return (
    <CardStyled
      isPerformanceVisible={isPerformanceVisible}
      viewAllComments={viewAllComments}
    >
      {["xxl", "xl", "lg"].includes(screen) ? (
        <div style={{ height: "100%", overflow: "hidden" }}>
          <div className="commentTabsDiv">
            <CustomTabs
              activeTab={mainactiveTab}
              setActiveTab={setMainActiveTab}
              tabs={maintabs}
              className=" fontSizeTab"
              customTabCSS={
                viewAllComments
                  ? " customCommentViewAllTabs"
                  : " customCommentTabs"
              }
              customContentCSS="customTabContentComment"
            ></CustomTabs>
          </div>
        </div>
      ) : (
        <DraggableModal
          isPaneOpen={isPaneOpen}
          togglePane={togglePane}
          onClose={onClosePaneHandler}
        >
          <div>
            <div className="commentDropdownDiv">
              <div>
                <Typography
                  variant={["xxl", "xl", "lg"].includes(screen) ? "h6" : "h6"}
                  color="black"
                >
                  Comments
                </Typography>
              </div>
              <div className="commentDropdownDiv2">
                <SingleSelectHookForm
                  disabled={false}
                  error={errors}
                  controlName={control}
                  placeholder="Select role"
                  width="100%"
                  isInPerformance={false}
                  options={tabs}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name={"fexRole"}
                  register={register}
                  rules={{
                    required: "You must select tab.",
                  }}
                  onChange={(selected: any) => {
                    console.log("selected", selected);
                    setTabComponent(selected);
                  }}
                  defaultValue={[tabs[0]]}
                />
              </div>
            </div>
            <div>
              {isCommentLoader ? (
                <div className="d-flex justify-content-center align-item-center">
                  <Spinner color="info"></Spinner>
                </div>
              ) : (
                <>
                  {Object.keys(tabComponent).length === 0
                    ? tabs[0].component
                    : tabComponent.component}
                </>
              )}
            </div>
            <div
              id="commentFooter"
              className="filterFooter studentPerformanceFooter"
            >
              <StudentAddComment
                refreshComment={refreshComment}
                setRefreshComment={setRefreshComment}
                lopReasonList={lopReasonList}
                lopActionList={lopActionList}
                viewAllComments={viewAllComments}
                subjects={subjects}
                filterState={filterState}
                setFilterState={setFilterState}
                isAddNewComment={isAddNewComment}
                setIsAddNewComment={setIsAddNewComment}
                isCommentEdit={isCommentEdit}
                setIsCommentEdit={setIsCommentEdit}
                isPaneOpenComment={isPaneOpenComment}
                scrollToHeader={scrollToHeader}
              />
            </div>
          </div>
        </DraggableModal>
      )}
    </CardStyled>
  );
};

export default StudentCommentSection;
